import {gsap} from 'gsap';

export default class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('.c-tabs');

    if (this.tabs.length === 0) return;

    this.init();

    this.showMore();
  }

  init() {
    this.tabs.forEach(tabContainer => {
      const tabItems = tabContainer.querySelectorAll('.c-tabs-link__item');
      const tabPanels = tabContainer.querySelectorAll('.c-tabs-panel__item');

      // Créer et ajouter l'indicateur s'il n'existe pas
      let indicator = tabContainer.querySelector('.c-tabs-indicator');
      if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'c-tabs-indicator';
        tabContainer.querySelector('.c-tabs-link').appendChild(indicator);
      }

      // Initialiser l'indicateur à la position de l'onglet actif
      this.initIndicator(tabContainer);

      // Ajouter les écouteurs d'événements pour chaque onglet
      tabItems.forEach(item => {
        item.addEventListener('click', () => this.switchTab(item, tabContainer));
      });
    });

    // Gérer le redimensionnement de la fenêtre
    window.addEventListener('resize', () => this.handleResize());
  }

  initIndicator(tabContainer) {
    const activeTab = tabContainer.querySelector('.c-tabs-link__item.active');
    const indicator = tabContainer.querySelector('.c-tabs-indicator');

    if (activeTab && indicator) {
      // Positionnement initial sans animation
      gsap.set(indicator, {
        width: activeTab.offsetWidth,
        x: activeTab.offsetLeft
      });
    }
  }

  switchTab(clickedTab, tabContainer) {
    const tabItems = tabContainer.querySelectorAll('.c-tabs-link__item');
    const indicator = tabContainer.querySelector('.c-tabs-indicator');
    const tabPanels = tabContainer.querySelectorAll('.c-tabs-panel__item');

    // Retirer la classe active de tous les onglets
    tabItems.forEach(tab => tab.classList.remove('active'));

    // Ajouter la classe active à l'onglet cliqué
    clickedTab.classList.add('active');

    // Animer l'indicateur
    this.animateIndicator(clickedTab, indicator);

    // Changer de panneau
    const tabId = clickedTab.getAttribute('data-tab');
    this.switchTabPanel(tabId, tabPanels);
  }

  animateIndicator(targetTab, indicator) {
    gsap.to(indicator, {
      width: targetTab.offsetWidth,
      x: targetTab.offsetLeft,
      duration: 0.5,
      ease: "back.out(1.7)"  // Effet de rebond
    });
  }


  switchTabPanel(tabId, panels) {
    const tl = gsap.timeline();

    // Trouver le panneau actuellement visible
    const currentPanel = Array.from(panels).find(panel => panel.style.display !== 'none');
    const targetPanel = Array.from(panels).find(panel => panel.getAttribute('data-panel') === tabId);

    if (currentPanel && currentPanel !== targetPanel) {
      // Masquer le panneau actuel
      tl.to(currentPanel, {
        opacity: 0,
        y: -10,
        duration: 0.2,
        onComplete: () => {
          currentPanel.style.display = 'none';
        }
      });
    }

    // Afficher le nouveau panneau
    if (targetPanel) {
      tl.set(targetPanel, {
        display: 'block',
        y: 10,
        opacity: 0
      }, currentPanel ? "-=0.1" : 0).to(targetPanel, {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "power1.out"
      });
    }
  }


  handleResize() {
    this.tabs.forEach(tabContainer => {
      const activeTab = tabContainer.querySelector('.c-tabs-link__item.active');
      const indicator = tabContainer.querySelector('.c-tabs-indicator');

      if (activeTab && indicator) {
        // Repositionnement instantané lors du redimensionnement
        gsap.set(indicator, {
          width: activeTab.offsetWidth,
          x: activeTab.offsetLeft
        });
      }
    });
  }

  showMore() {
    this._btn = document.querySelector('.c-tabs-panel__item-show-more');

    if (this._btn) {
      this._parentPanel = this._btn.parentNode;
      this._overlay = this._parentPanel.querySelector('.c-tabs-panel__item--overlay');

      this._btn.addEventListener('click', () => {
          this._overlay.classList.toggle('active');

          this._btn.innerHTML = this._btn.innerHTML === 'Afficher plus' ? 'Afficher moins' : 'Afficher plus';
        }
      )
    }
  }
}
